<!--  -->
<template>
  <ul class="skeketon">
    <li class="skeketon-item"  v-for="i in 4" :key="i">
      <div class="skeketon-item-img"></div>
      <div class="skeketon-item-info">
        <p v-for="(width,index) in [50, 50, 100, 100, 50]" :key="index" :style="{width:`${width}%`}"></p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  components: {},

  data () {
    return {
    }
  },

  computed: {},

  created () {},

  methods: {}
}

</script>
<style lang='scss' scoped>
.skeketon{
  @include skeletonBlink();
  &-item{
    width: 100%;
    height: 140px;
    padding: 10px;
    display: flex;
    background: var(--APP_skeleton_background_color);
    box-sizing: border-box;
    margin-bottom: 8px;
    &-img{
      width: 120px;
      height: 120px;
      background: var(--APP_skeleton_color);
    }
    &-info{
      margin-left: 10px;
      width: 225px;
      display: flex;
      flex-direction: column;
      justify-content:space-between;
      >p{
        height: 15px;
        background: var(--APP_skeleton_color);
      }
    }
  }
}

</style>
